import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

// WHO the person is in the active org — the ROLE, and the one derived fact
// every door reads. The capability layer that used to sit beside it (six keys
// the server read once and the client hid buttons on) is gone: a hidden button
// was never a permission, and the two keys anything read were exactly
// Membership#admin?.
export function usePermissions() {
  const auth = useAuthStore()

  const role = computed(() => auth.currentMembership?.attributes.role || null)

  // The tiers the server treats as running the organization (Membership#admin?:
  // settings writes, member management, the funnel's queues). Read off the
  // ROLE so the client never opens a door the server answers with a 404.
  const isAdmin = computed(() => role.value === 'admin' || role.value === 'owner')

  return {
    membership: computed(() => auth.currentMembership),
    role,
    isAdmin,
  }
}
